import { Box, Container, Typography, Stack, Divider } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PageHero from '../components/common/PageHero';
import AnimatedSection from '../components/common/AnimatedSection';
import { useLegal } from '../hooks/usePublicApi';
import { agb as staticAgb } from '../data/legal';

export default function AGB() {
  const { legal: apiData } = useLegal('agb');
  const agb = apiData || staticAgb;

  return (
    <>
      <Helmet>
        <title>AGB — Süd Ausbau GmbH</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen der Süd Ausbau GmbH." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://sued-ausbau.de/agb" />
      </Helmet>

      <PageHero title="Allgemeine Geschäftsbedingungen" />

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          <AnimatedSection>
            <Stack spacing={4}>
              {(agb.sections || []).map((section, i) => (
                <Box key={i}>
                  <Typography variant="h5" sx={{ mb: 2 }}>
                    {section.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                    {section.content}
                  </Typography>
                  {i < (agb.sections || []).length - 1 && <Divider sx={{ mt: 4 }} />}
                </Box>
              ))}
            </Stack>
          </AnimatedSection>
        </Container>
      </Box>
    </>
  );
}
